import { render, staticRenderFns } from "./HorizontalList.vue?vue&type=template&id=4ce60196&scoped=true&"
import script from "./HorizontalList.vue?vue&type=script&lang=js&"
export * from "./HorizontalList.vue?vue&type=script&lang=js&"
import style0 from "./HorizontalList.vue?vue&type=style&index=0&id=4ce60196&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ce60196",
  null
  
)

export default component.exports